export const ETHICS = Array.from({ length: 6 }, (_, i) => `rules.${i}` as const);
